import { Avatar as MantineAvatar, MantineSize } from "@mantine/core";
import React from "react";

const Avatar: React.FC<{ id: string; name: string; size?: MantineSize | (string & {}) | number }> = ({
  id,
  name,
  size = "md",
}) => {
  return <MantineAvatar src={`/api/image/profilePictures/${id}`} name={name} size={size} />;
};

export default Avatar;
